import { Element } from '@ritabygglov/core';
import {
  createDimensionId,
  parseDimensionId as parseDimensionIdHelper,
} from '../../../../helpers/dimensionIds';
import { DimensionDragInfo } from '../../../../types';
import { dimensionStrategies } from './dimensionDragStrategies';

export type DimensionUpdate = {
  updatedElement: Element;
  originalElement: Element;
};

export const parseDimensionId = (id: string): DimensionDragInfo | null => {
  const idInfo = parseDimensionIdHelper(id);
  if (!idInfo) return null;

  return {
    elementId: idInfo.elementId,
    dimensionType: idInfo.dimensionType,
    segmentIndex: idInfo.segmentIndex,
    startOffset: 0,
    startMouseX: 0,
    startMouseY: 0,
  };
};

export const getStartOffset = (
  element: Element,
  dragInfo: DimensionDragInfo
): number => {
  const strategy = dimensionStrategies[dragInfo.dimensionType];
  return strategy ? strategy.getStartOffset(element, dragInfo) : 15;
};

export const calculateDimensionUpdate = (
  element: Element,
  dragInfo: DimensionDragInfo,
  currentX: number,
  currentY: number
): DimensionUpdate | null => {
  const strategy = dimensionStrategies[dragInfo.dimensionType];
  if (!strategy) return null;

  const newOffset = strategy.calculate(element, dragInfo, currentX, currentY);
  const updatedElement = strategy.updateElement(element, newOffset, dragInfo);

  return {
    updatedElement,
    originalElement: element,
  };
};

export const formatDimensionId = (dragInfo: DimensionDragInfo): string => {
  return createDimensionId(
    dragInfo.elementId,
    dragInfo.dimensionType,
    dragInfo.segmentIndex
  );
};
